// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Tgjnk","title":"styles_title__U9vuu","subtitle":"styles_subtitle__Kuhjz"};